module.exports = __webpack_public_path__ + "static/hk-logo-fdabd4030d155fb4e0ac15e030b52ebc.png";